module.exports = __webpack_public_path__ + "img/avatar-wiebe-elsinga.58dbb670.jpg";